import { getAnalyticsContext } from "./context";
import { extractEntityContext } from "./entity";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

let routeStartTime = Date.now();

/**
 * Generate or reuse a session ID
 */
function getSessionId() {
  let id = localStorage.getItem("trekko_session_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("trekko_session_id", id);
  }
  return id;
}

const sessionId = getSessionId();

/**
 * Build full backend URL safely
 */
function buildUrl(endpoint) {
  if (!API_BASE_URL) return endpoint;
  return `${API_BASE_URL.replace(/\/$/, "")}${
    endpoint.startsWith("/") ? "" : "/"
  }${endpoint}`;
}

/**
 * Send analytics event safely
 */
function sendEvent(endpoint, payload) {
  const body = {
    sessionId,
    timestamp: Date.now(),
    ...getAnalyticsContext(), // locale, tenant, platform
    ...payload, // path, duration, entity, funnel
  };

  const DEBUG_ANALYTICS = process.env.VUE_APP_ANALYTICS_DEBUG === "true";
  const url = buildUrl(endpoint);

  if (DEBUG_ANALYTICS) {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return;
  }

  navigator.sendBeacon(url, JSON.stringify(body));
}

/**
 * Initialize analytics ONCE
 */
export function initAnalytics(router) {
  // Initial page view
  sendEvent("/analytics/page-view", {
    path: router.currentRoute.value.fullPath,
    ...extractEntityContext(router.currentRoute.value),
  });

  // Track route duration
  router.beforeEach((to, from, next) => {
    if (from.fullPath) {
      sendEvent("/analytics/page-duration", {
        path: from.fullPath,
        durationMs: Date.now() - routeStartTime,
        ...extractEntityContext(from),
      });
    }

    routeStartTime = Date.now();
    next();
  });

  // Track page views
  router.afterEach((to) => {
    sendEvent("/analytics/page-view", {
      path: to.fullPath,
      ...extractEntityContext(to),
    });
  });

  // Handle tab close / background
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      sendEvent("/analytics/page-duration", {
        path: router.currentRoute.value.fullPath,
        durationMs: Date.now() - routeStartTime,
        ...extractEntityContext(router.currentRoute.value),
      });
    }
  });
}
